// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForecastSchema } from './v1/forecastSchema';
import { v1ForecastsUpdateSchema } from './v1/forecasts/updateSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateTaskPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Task ID"),
});

export const updateTaskHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Task updated
 */
export const updateTask200Schema = z.lazy(() => v1ForecastSchema);

/**
 * @description Unauthorized
 */
export const updateTask401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Task not found
 */
export const updateTask404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation errors
 */
export const updateTask422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateTaskMutationRequestSchema = z.lazy(() => v1ForecastsUpdateSchema);

export const updateTaskMutationResponseSchema = z.lazy(() => updateTask200Schema);
